import { isEmpty } from 'lodash/lang';

const icons = {
  Table: 'table_chart',
  NewTable: 'table_chart',
  Logs: 'format_list_numbered',
  LogChecks: 'format_list_numbered',
  Procedure: 'medical_services',
  Reminder: 'alarm_on',
  Comments: 'forum',
  Custom: 'extension',
  Checklist: 'playlist_add_check',
  PatientStatus: 'contact_emergency',
  PatientStipend: 'monetization_on',
  Outreach: 'people_outline',
  ChartReview: 'bar_chart',
  ICF: 'description'
};
const iconsSuit = {
  Table: 'material-outline',
  NewTable: 'material-outline',
  Logs: 'material-outline',
  LogChecks: 'material-outline',
  Procedure: 'material',
  Reminder: 'material-outline',
  Comments: 'material-outline',
  Custom: 'material-outline',
  Checklist: 'material-outline',
  PatientStatus: 'material',
  PatientStipend: 'material-outline',
  Outreach: 'material-outline',
  ChartReview: 'material-outline',
  ICF: 'material-outline'
};

export function getIcon(type) {
  return icons[type.replace(' ', '')];
}

export function getIconSuit(type) {
  return iconsSuit[type.replace(' ', '')];
}

export function logSnapshotReviewStateHasRecords(logSnapshotReviewState) {
  return !isEmpty(logSnapshotReviewState?.logSnapshotState.rows);
}

export function logCheckSnapshotReviewStateHasRecords(logCheckSnapshotReviewState) {
  return !isEmpty(logCheckSnapshotReviewState?.logCheckSnapshotState?.logCheckSnapshot?.logCheckAnswers);
}

export function itemGroupSnapshotReviewStateHasRecordsOrNotPerformed(itemGroupSnapshotReviewState) {
  return (
    !isEmpty(itemGroupSnapshotReviewState?.itemGroupSnapshotState.rows) ||
    itemGroupSnapshotReviewState?.itemGroupSnapshotState?.dataStatus?.notPerformed
  );
}
